var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490 720",
    width: 490,
    height: 720,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#cc934c}.b{fill:#fbe979}.c{fill:#ffc654}.d{fill:#e3bd5e}.e{fill:#e09d38}.f{fill:#a39c95}.g{fill:#f5f5f5}.h{fill:#a68efe}.i{fill:#50e0d5}.j{fill:#403531}.k{fill:#685750}.l{fill:#8a1c14}.m{fill:#0a0808}.n{fill:#c84030}.o{fill:#574943}.p{fill:#d8d1c7}.q{fill:#87817c}.r{fill:#e6e1dd}.s{fill:#c2bebb}.t{fill:#b5afa7}.u{fill:#d66b24}.v{fill:#fdbd6f}.w{fill:#fdb053}.x{fill:#ef8f2d}.y{fill:#211a1a}.z{fill:#5e4439}.A{fill:#f0c6b4}.B{fill:#362c29}.C{fill:#c7a495}.D{fill:#d1d1d1}.E{fill:#544540}.F{fill:#87511b}.G{opacity:.3}.H{fill:#a16739}.I{fill:#573711}.J{fill:#b87139}.K{fill:#bfa69d}.L{fill:#f7f2e8}.M{fill:#bfb8af}.N{fill:#785b56}.O{fill:#836e69}.P{fill:#fa5c52}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m87.2 669.7l-5-22.9 34.7-12.9v18.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m16.8 529h-7.5l-8.8-9.4 29.7-17.1 16.2 9.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m132.5 658.9l-11.4-19.9 29.6-17.1 11.5 19.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m121.1 639l4.6-10.2 12.5-12.3 17.2-4.8-4.7 10.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m43 576.1l-3-31.6 32.7-13.6v28.1l-10.6 10z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m81.7 620.3l-22.2-15.6 8.8-12.1 20.9-5 13.7 7.9-0.6 14.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m44 505.6l-7.4-5.5-4-14.4 29.6-17.1 11.5 19.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m55.3 506.7l-11.3-1.1 29.7-17.1 11.2 1.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "d",
    d: "m121.1 639l11.4 19.9-22.6 13.1-11.4-19.9-11.3-1.1v18.7l-31.9-18.4v-18.8l-11.3-11.8-11.4 6.6-22.6-39.2 11.5-6.6-4.7-15.6-16.3-9.4v-36.9l16.3 9.4 4.7-10.3-11.5-19.9 22.6-13.1 11.4 19.9 11.3 1.1v-18.7l31.9 18.4v18.8l11.3 11.8 11.4-6.6 22.7 39.2-11.5 6.6 4.6 15.7 16.3 9.3v36.9l-16.3-9.3zm-21.6-57.4l-16.5-28.6-23.4-13.6-16.6 9.6v27l16.6 28.7 23.4 13.5 16.5-9.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m87.2 506.4l-31.9-18.4 29.6-17.1 32 18.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m132.6 569.6l-22.7-39.2 29.7-17.1 22.6 39.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m142 638.1v-36.9l29.6-17.1v36.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m87.2 525.2v-18.8l29.7-17.1v18.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m125.7 591.9l-4.6-15.7 29.6-17.1 4.7 15.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m59.5 604.7l-16.5-28.6 29.7-17.1 16.5 28.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m98.5 537l-11.3-11.8 29.7-17.1 11.2 11.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m142 601.2l-16.3-9.3 29.7-17.2 16.2 9.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m202.9 718.7l-2.9-13.3 20.1-7.4v10.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m162.2 637.3h-4.3l-5.1-5.4 17.1-9.9 9.4 5.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m229.1 712.5l-6.6-11.5 17.1-9.9 6.7 11.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m222.5 701l2.7-6 7.2-7.1 9.9-2.8-2.7 6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m177.4 664.5l-1.8-18.2 18.9-7.9v16.3l-6.1 5.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m199.7 690.1l-12.8-9 5.1-7 12.1-2.9 7.9 4.6-0.4 8.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m177.9 623.8l-4.2-3.2-2.4-8.3 17.1-9.9 6.7 11.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m184.5 624.5l-6.6-0.7 17.2-9.9 6.5 0.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "d",
    d: "m222.5 701l6.6 11.5-13.1 7.5-6.6-11.5-6.5-0.7v10.9l-18.4-10.7v-10.8l-6.6-6.9-6.6 3.9-13-22.7 6.6-3.8-2.7-9.1-9.4-5.4v-21.3l9.4 5.4 2.7-5.9-6.6-11.6 13-7.5 6.6 11.5 6.6 0.7v-10.9l18.4 10.7v10.8l6.5 6.9 6.6-3.9 13.1 22.7-6.6 3.8 2.7 9.1 9.4 5.4v21.3l-9.4-5.4zm-12.5-33.2l-9.6-16.5-13.5-7.8-9.6 5.5v15.6l9.6 16.6 13.5 7.8 9.6-5.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m202.9 624.3l-18.4-10.7 17.1-9.9 18.5 10.7z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m229.1 660.8l-13.1-22.7 17.2-9.8 13.1 22.6z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m234.6 700.4v-21.3l17.1-9.9v21.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m202.9 635.1v-10.8l17.2-9.9v10.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m225.2 673.7l-2.7-9.1 17.1-9.9 2.7 9.1z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m186.9 681.1l-9.5-16.6 17.1-9.8 9.6 16.5z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m209.4 642l-6.5-6.9 17.2-9.9 6.4 6.9z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m234.6 679.1l-9.4-5.4 17.1-9.9 9.4 5.4z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m53.8 484.8l-2.9-13.3 20.1-7.5v10.9z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m13.1 403.4h-4.3l-5.1-5.4 17.1-9.9 9.4 5.4z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m80 478.5l-6.6-11.5 17.1-9.9 6.6 11.5z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m73.4 467l2.6-5.9 7.3-7.1 9.9-2.8-2.7 5.9z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m28.2 430.6l-1.7-18.2 18.9-7.9v16.2l-6.1 5.8z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m50.6 456.2l-12.8-9 5-7 12.1-2.9 7.9 4.6-0.3 8.3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m28.8 389.9l-4.3-3.2-2.3-8.3 17.1-9.9 6.6 11.5z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m35.3 390.5l-6.5-0.6 17.1-9.9 6.6 0.6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "d",
    d: "m73.4 467l6.6 11.5-13.1 7.6-6.6-11.5-6.5-0.7v10.9l-18.5-10.7v-10.8l-6.5-6.9-6.6 3.8-13.1-22.6 6.7-3.8-2.7-9.1-9.4-5.4v-21.3l9.4 5.4 2.7-6-6.7-11.5 13.1-7.5 6.6 11.5 6.5 0.6v-10.8l18.5 10.7v10.8l6.5 6.9 6.6-3.9 13.1 22.7-6.6 3.8 2.6 9 9.4 5.5v21.3l-9.4-5.4zm-12.4-33.2l-9.6-16.5-13.5-7.9-9.6 5.6v15.6l9.6 16.5 13.5 7.8 9.6-5.5z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m53.8 390.4l-18.5-10.7 17.2-9.9 18.5 10.7z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m80 426.9l-13.1-22.7 17.2-9.9 13 22.7z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m85.4 466.5v-21.3l17.2-9.9v21.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m53.8 401.2v-10.8l17.2-9.9v10.8z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m76 439.7l-2.6-9 17.1-9.9 2.7 9z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m37.8 447.2l-9.6-16.6 17.2-9.9 9.5 16.6z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m60.3 408.1l-6.5-6.9 17.2-9.9 6.4 6.9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m85.4 445.2l-9.4-5.5 17.2-9.9 9.4 5.5z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m330.4 632l-10.9 17.1-61.9 3.4-73.5-42.3-62.1-78.3-35.9-95.3v-80.3l35.9-54.7 17.2 1z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m358.3 585.4v-79.7l-34.6-88.9-59.7-74.4-69.1-39.8-59.7 5.3-34.5 49.1v79.7l34.5 89 59.7 74.3 69.1 39.9 59.7-5.4z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m229.1 471l129.2 74.6v39.8l-34.6 49.1-59.7 5.4-69.1-39.9z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m323.7 416.8l-59.7-74.4-34.9-20.1v148.7l129.2 74.6v-39.9z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m234.4 574v-79.8l-10.5-6.1v79.8l5.5 9z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m226.4 578.7l3-1.8v-79.8l-10.5-6v79.7l3.1 5.3z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m222.2 446.9l-10.2 5.9v16.7l10.2 17.7 14.5 8.3 10.2-5.9v-16.6l-10.2-17.7z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m212.5 452.6l-10.3 5.8v16.7l10.3 17.7 14.4 8.4 10.2-5.9v-16.7l-10.2-17.7z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m285.1 435l-5.1-3-42.7 24.5 8.8 15.1 42.6-24.5v-5.9z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m280.2 437.9l-5.1-3-42.7 24.6 8.7 15 42.7-24.5v-5.9z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m233.9 360.3l-4.4 2.6-8.9-26.5 4.4-2.5 8.9 5.1z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m233.9 608.6l-4.4 2.5-8.9-26.5 4.4-2.5 8.9 5.1z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m323.3 525.4l4.4-2.6 18.5 10.7v10.2l-4.5 2.6z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m108.3 401.2l4.4-2.5 18.5 10.7v10.2l-4.4 2.6z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m295.8 593.4l6.3-3.7 13 22.7-6.2 3.6z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m143.8 330.1l6.3-3.6 13 22.6-6.3 3.6z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m302.1 436.6l-6.3-10.9 13.1-7.6 6.2 10.9z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m150.1 524.3l-6.3-10.9 13.1-7.5 6.2 10.9z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m229.5 362.9l-8.9-5.2v-21.3l8.9 5.1z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m229.5 611.1l-8.9-5.1v-21.4l8.9 5.2z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m323.3 535.6v-10.2l18.4 10.6v10.3z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m108.3 411.5v-10.3l18.5 10.7v10.3z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m291.4 595.9l6.2-3.6 13.1 22.6-6.3 3.6z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m139.4 332.6l6.2-3.6 13.1 22.6-6.3 3.6z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m297.6 439.1l-6.2-10.9 13-7.5 6.3 10.8z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m145.6 526.8l-6.2-10.8 13-7.6 6.3 10.9z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "p",
    d: "m364 513.5v87.7l-38 54.1-65.9 5.9-76-43.9-65.8-81.9-38-97.9v-87.8l38-54.1 65.8-5.9 76 43.9 65.8 81.9zm-13-3.5l-34.5-88.9-59.8-74.4-69-39.8-59.8 5.3-34.5 49.1v79.7l34.5 89 59.8 74.3 69 39.9 59.8-5.4 34.5-49.1z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m398.7 581.2l-34.7 20v-87.7l34.7-20.1z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m360.7 635.2l-34.7 20.1 38-54.1 34.7-20z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m294.9 313.5l-34.8 20.1-76-43.9 34.8-20z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m360.7 395.4l-34.8 20.1-65.8-81.9 34.8-20.1z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m218.9 269.7l-34.8 20-65.8 5.9 34.8-20.1z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m398.7 493.4l-34.7 20.1-38.1-98 34.8-20.1z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m426.1 616.7l-3-13.7 20.7-7.7v11.2z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m384.1 532.8h-4.4l-5.2-5.6 17.6-10.2 9.7 5.6z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m453.1 610.3l-6.8-11.9 17.6-10.2 6.9 11.9z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m446.3 598.4l2.7-6.1 7.5-7.3 10.2-2.9-2.8 6.1z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m399.8 560.9l-1.8-18.8 19.4-8.2v16.8l-6.2 5.9z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m422.8 587.3l-13.2-9.4 5.2-7.2 12.5-3 8.2 4.8-0.4 8.6z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m400.4 518.9l-4.4-3.3-2.5-8.6 17.7-10.2 6.8 11.9z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m407.1 519.6l-6.7-0.7 17.6-10.2 6.7 0.6z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "x",
    d: "m446.3 598.4l6.8 11.9-13.5 7.7-6.8-11.8-6.7-0.7v11.2l-19-11v-11.2l-6.7-7-6.9 3.9-13.4-23.3 6.8-4-2.8-9.3-9.6-5.6v-22l9.6 5.6 2.8-6.1-6.8-11.9 13.4-7.8 6.9 11.9 6.7 0.7v-11.2l19 11v11.1l6.7 7.1 6.8-4 13.5 23.4-6.8 3.9 2.7 9.4 9.7 5.6v22l-9.7-5.6zm-12.8-34.2l-9.9-17.1-13.9-8-9.9 5.7v16.1l9.9 17 13.9 8.1 9.9-5.7z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m426.1 519.4l-19-11 17.6-10.2 19.1 11z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m453.1 557l-13.5-23.4 17.7-10.1 13.5 23.3z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m458.7 597.9v-22l17.7-10.2v22z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m426.1 530.5v-11.1l17.7-10.2v11.2z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m449 570.3l-2.7-9.4 17.6-10.2 2.8 9.4z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m409.6 577.9l-9.8-17 17.6-10.2 9.9 17z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m432.8 537.6l-6.7-7.1 17.7-10.1 6.7 7z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m458.7 575.9l-9.7-5.6 17.7-10.2 9.7 5.6z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m418.8 511.2l-4.3-19.2 29.2-10.8v15.6z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m359.8 393.3h-6.3l-7.3-7.9 24.8-14.3 13.6 7.8z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m456.7 502.1l-9.5-16.6 24.8-14.4 9.6 16.7z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m447.2 485.5l3.8-8.6 10.5-10.3 14.4-4.1-3.9 8.6z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m381.8 432.7l-2.6-26.4 27.4-11.4v23.5l-8.8 8.4z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m414.2 469.8l-18.6-13.1 7.3-10.2 17.6-4.1 11.4 6.6-0.5 12.2z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m382.6 373.7l-6.2-4.6-3.4-12.1 24.8-14.3 9.6 16.7z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m392.1 374.7l-9.5-1 24.8-14.3 9.5 0.9z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "d",
    d: "m447.2 485.5l9.5 16.6-18.9 11-9.6-16.7-9.4-0.9v15.7l-26.7-15.5v-15.7l-9.5-9.9-9.6 5.5-18.9-32.8 9.6-5.5-3.9-13.1-13.6-7.9v-30.9l13.6 7.9 3.9-8.6-9.6-16.7 18.9-11 9.6 16.7 9.5 1v-15.8l26.7 15.5v15.7l9.4 9.9 9.6-5.5 19 32.8-9.6 5.5 3.8 13.1 13.7 7.9v30.9l-13.7-7.8zm-18.1-48.1l-13.8-24-19.6-11.3-13.9 8v22.6l13.9 24 19.6 11.3 13.8-8z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m418.8 374.4l-26.7-15.5 24.8-14.3 26.8 15.5z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m456.8 427.3l-19-32.8 24.9-14.4 18.9 32.8z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m464.7 484.7v-30.9l24.8-14.3v30.9z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m418.8 390.1v-15.7l24.9-14.3v15.7z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m451 445.9l-3.8-13.1 24.8-14.3 3.9 13.1z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m395.6 456.7l-13.8-24 24.8-14.3 13.9 24z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m428.2 400l-9.4-9.9 24.9-14.3 9.3 9.9z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m464.7 453.8l-13.7-7.9 24.9-14.3 13.6 7.9z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m152.1 169.7l-8.7-3-2 0.9 4.9 17.8 2.7 17.7 4.8 9.4 2.1-0.9-1-15.5v-12.5z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "m158.7 166.7l-8-3.3-7.3 3.3 4.9 17.9 2.7 17.7 4.9 9.3 9-3.5 1.6-13.6-2.5-12z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m300.9 107l-2.6 6.6-9.9 6.3-1.4-11 6.9-5.4z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m303.8 113l13.3 11.5 3.2 11.4-2.5 5.3-3.2 0.4-0.3-2.6-10.5-2-4.8-3.5 2.3-2.7-5-5.7-1.2-4 1.3-9.4z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m295.9 103.5l7.9 9.5-5.7 2.2-3 5.9-9.3-8.8z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m267.1 37.8l6 5 4.7 35.5 23.1 28.7-7.8 2.6-4.7 10.3-25.5-24.8-7.1-28.4z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m247.8 125.1l-2.6 10.1-33.7 56.1-20-2.7h-26l-9.6-9.6 1.5-15.4 37.7-3.2 14.3-14.4z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m238.6 286.3l8.8 8.2 16.4 9.9v1.9l-4.6 4.1h-9.2l-12.1-5.6-4.6-8.9-6-5.1v-1.9z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "m247.2 281.1l3.8 7.5 11.5 10.5 1.3 5.3-4.6 4.1h-9.2l-12.1-5.6-4.6-8.8-6-5.2-1.1-13.5z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m191.5 131.1l1.3 17.3 31.3 71.9v56.3l10.4 6h16.1l2.2-72-20.5-65.4 15.5-20.1-37.4-8.1z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m192.5 144.1l0.3 4.3 1.3 3 17.1-23.5-16.4 4.7z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m249.3 118.2l-1.5 6.9-9.1 5.7-24.2-0.6-16.7-9.7 9.1-10.4z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m240 57.9l21.9-1.7 3.2 18.3-8.1 24.5-5.4 17.8-11.6 7.6-20.9 0.7-22.3-13z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m256.3 58.6l5.6 13.9-4.9 26.5 14.5-26.4-7.1-29.8-7.4 3.5z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m234.5 32.1l-1.6 5.7-0.6 9.9 7.9 13.6 9.1 3.7h3.9l2-3 3.9-12.3-12-19.6z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m227.9 40.3l-13.4 8-11.8 16.8-10.2 30-20.6 15.5-1.2 22.2 18.2 16.6 39.4-37.8 16.9-32-4.1-19.8z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m196.2 84.1l17.3-4.3-5-3.9-10.6 3.3z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m258.7 56.6l3.2 5.4-0.8-11.1-4.1-0.6z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m253.9 50.4l1.3 11.6 3.5-5.4-0.5-6.2z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m270.3 18l0.8 10.3-1.5 2.2v9.2l-4.2 11.8-6.7 3.4-17.2-9.7-0.7-5.9-4.2-2.8-1.4-3.3-0.7-9.7 22.1-12.1z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "E",
    d: "m235.2 33.2l1-6.7h3.2l2.7 4.1h1.9l1.2-2.5 5.1-0.9 2.1-4.3 14.2-1.3 3.9-3.8-5.8-12.5-12.7-5.3-12 2.6-6.4 8.2-3 11.6 2.2 8.6z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "F",
    d: "m124.6 184.6l-29.1-49.5 13-22.9 34.1 49.4z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "G",
    d: "m131.1 173.2l-29.1-49.5 6.5-11.5 29.1 49.6z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "H",
    d: "m142.4 151.7l-27.3-52.7 5.6-3.3 34.4 49.5z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "F",
    d: "m131.2 171.4l-29.1-49.5 13-22.9 29.1 49.6-3.7 10.4z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "I",
    d: "m154.2 146l-4.5 0.1-4.8 2.8-20.3 35.7 2.7 0.9 4.5-0.1 3.8-0.9 20.3-35.7z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "I",
    d: "m132.1 171.4l13.7-15.3 6.7-6.3 0.7-1.5 2.7 0.5-0.8-3.6-5.3 0.1-5.6 3.3-13 22.8z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m149.8 145.3l-29.1-49.6h5.3l29.1 49.5z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m111.8 127.6l-3.6 6.2-3.2-5.5 3.5-6.3z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "K",
    d: "m112.7 127.6l-3.6 6.2h-0.9l3.6-6.2z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "L",
    d: "m112.7 127.6l-3.2-5.6h-1l3.3 5.6z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m110 128.8l-1.2 0.4 0.2-0.8-0.1-1 1.1 0.2z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "K",
    d: "m109.4 129.9h-0.9l0.1-0.8 0.5-0.3h0.9z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m109.1 127.6l-1.4-2.5h-0.7l-0.6 1.1v1.2l1.5 2.5h0.6l0.6-1.1z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "L",
    d: "m109.1 127.6l-1.4-2.5h0.8l1.5 2.5z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m130.1 158.7l-3.6 6.3-3.2-5.5 3.5-6.3z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "K",
    d: "m131 158.7l-3.6 6.3h-0.9l3.6-6.3z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "L",
    d: "m131 158.7l-3.3-5.5h-0.9l3.3 5.5z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m128.3 160l-1.2 0.4 0.2-0.8-0.2-1.1 1.2 0.3z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "K",
    d: "m127.7 161h-0.9l0.1-0.7 0.5-0.3h0.9z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m127.4 158.8l-1.5-2.5h-0.7l-0.5 1v1.2l1.4 2.6 0.7-0.1 0.6-1z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "L",
    d: "m127.4 158.8l-1.5-2.5h0.9l1.5 2.5z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m133 111.1l-1.1-0.6-0.5-0.8 0.4-0.7h1l1.1 0.6 0.4 0.9-0.3 0.6z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m131.9 110.5l-0.5-0.8-0.5 1 0.5 0.8 0.6-0.9z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m133 111.1l-1.1-0.6-0.5 1 1 0.6 0.7-0.9z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m134 111.1h-1l-0.6 1h1z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "N",
    d: "m135.8 105.8l-0.6-0.4-0.3-0.5 0.2-0.3h0.5l0.7 0.3 0.2 0.5-0.2 0.3z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m135.2 105.4l-0.3-0.5-2.8 4.9 0.3 0.5 2.8-4.8z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m135.8 105.8l-0.6-0.4-2.8 4.9 0.6 0.3 2.8-4.8z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m136.3 105.7l-0.5 0.1-2.8 4.8h0.6z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m144.2 130.1l-1.1-0.6-0.5-0.8 0.3-0.6 1-0.1 1.1 0.7 0.5 0.8-0.3 0.6z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m143.1 129.5l-0.5-0.8-0.6 1 0.5 0.8 0.6-0.9z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m144.2 130.1l-1.1-0.6-0.6 1 1.1 0.6 0.6-0.8z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m145.2 130.1h-1l-0.6 1h1z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "N",
    d: "m146.9 124.8l-0.6-0.4-0.3-0.5 0.2-0.3h0.6l0.6 0.3 0.3 0.5-0.2 0.4z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m146.3 124.4l-0.3-0.5-2.7 4.9 0.3 0.5 2.7-4.8z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m146.9 124.8l-0.6-0.4-2.7 4.9 0.6 0.3 2.8-4.8z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m147.5 124.8h-0.6l-2.7 4.8h0.5z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m135.6 103.5l1.7-1h1.7l0.6 1-0.9 1.4-1.7 1.1h-1.6l-0.7-1z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m137.3 102.5h1.7l-1-1.6h-1.6l0.8 1.5z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m135.6 103.5l1.7-1-0.9-1.6-1.8 1 0.8 1.6z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m134.7 105l0.9-1.5-1-1.6-0.8 1.4z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "N",
    d: "m146.3 121.2l1.2-0.7h1.2l0.4 0.7-0.5 1-1.3 0.8h-1.2l-0.4-0.7z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m147.5 120.5h1.2l-10.2-17.5h-1.2l10.1 17.4z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m146.3 121.2l1.2-0.7-10.2-17.5-1.3 0.8 10.1 17.4z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m145.7 122.3l0.6-1.1-10.3-17.4-0.6 1z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m146.7 122.5l1.8-1h1.6l0.6 1-0.8 1.4-1.7 1.1h-1.7l-0.6-1z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m148.5 121.5h1.6l-0.9-1.6h-1.7l0.8 1.5z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m146.7 122.5l1.8-1-1-1.6-1.7 1 0.7 1.6z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m145.9 124l0.8-1.5-0.9-1.6-0.9 1.4z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m141.8 96.5l-8 5.6-1.6 9.9 5.4 10.8 7.5-1.6-2.6-4.3 1.2-1.3 2.1-0.1 2 3.5 5.1-6.4-0.7-11.2z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m145.2 88.5l-3.9 7 3.9 6.3h7.9l4.3-6.7z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m222.3 68.3l-7.8-13.4-53 3.3-18.9 29.5 3.5 9.3h12.2l13.8-18.8 41.4 1.6z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m246.4 59.8l2.9 5.2-8.2-2.5z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m232.9 37.8l3.5 11.7 10 10.3-5.6 7.5-10.2-14.5-2.7-12.5z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m252.8 68.1l5.7 22.6-3.3 14.1 8.7-14.1-8.1-24-1.9-0.9z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "P",
    d: "m249.3 65l5.9-3 1.1 3-0.5 1.7-3 1.4-2.2-0.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.0029d394a4c6284e7ebcb41a31b9ba09.svg";
export { ForwardRef as ReactComponent };